<template>
    <vs-row>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">event</span>
            <label>Date of Birth</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex justify-between items-center p-1">
            <flat-pickr v-if="editBox"
            v-model="clientDetails.bio.dob"
          />
            <p v-else><span v-if="clientDetails.bio.dob">{{clientDetails.bio.dob | dateFormatLocalization }}</span>
              <span v-else>Not Available</span>
            </p>
            <vs-tooltip position="top" color="primary" text="Edit" v-if="!editBox">
              <vs-button icon="border_color" type="border" @click="handleEdit()" >
              <!-- <span class="material-icons-outlined small_icon cursor-pointer" ></span> -->
              </vs-button>
            </vs-tooltip>
            <vs-tooltip position="top" color="primary" text="Save" v-if="editBox">
              <vs-button icon="save" type="border" @click="Update">
              <!-- <span class="material-icons-outlined small_icon cursor-pointer">save</span> -->
              </vs-button>
            </vs-tooltip>
            <!-- <span class="material-icons-outlined small_icon cursor-pointer" @click="editBox = true" v-if="!editBox">border_color</span>
            <span class="material-icons-outlined small_icon cursor-pointer" @click="Update" v-if="editBox">save</span> -->
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">flag</span>
            <label>Nationality</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="clientDetails.bio.nationality" />
             <p v-if="!editBox">{{clientDetails.bio.nationality?clientDetails.bio.nationality:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">language</span>
            <label>Website</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="clientDetails.bio.website" />
            <p v-else>{{clientDetails.bio.website?clientDetails.bio.website:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex p-1">
            <span style="margin-top: 4px;" class="material-icons-outlined small_icon">person</span>
            <label>Biography</label>
        </vs-col>        
        <vs-col vs-lg="8" vs-sm="12" class="flex items-end p-1">
            <vs-textarea v-if="editBox" v-model="clientDetails.bio.biography" />
            <p v-else style="max-height: 100px; overflow: auto" class="vertical_scrollbar"> {{clientDetails.bio.biography?clientDetails.bio.biography:'Not Available'}}</p>
            <!-- <a v-if="clientDetails.bio.biography" style="white-space: nowrap; cursor: pointer;" class="inline-block" @click="showMore = !showMore">
                <span v-if="showMore">Read More</span>
                <span v-else>Show Less</span>
            </a> -->
         
        </vs-col> 
    </vs-row>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { StudentMixins } from '@/views/pages/v1/StudentProfile/mixins/studentMixin.js'


export default {
  components: {
    flatPickr
  },
  mixins: [StudentMixins],
  props: {
    clientDetails:{
      default:{}
    }
  },
  data () {
    return {
      showMore: true,
      editBox: false
    }
  },
  methods: {
    handleEdit () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editBox = true
    },
    async Update () {
      const isValid = this.clientDetails.bio.website ? this.isValidURL(this.clientDetails.bio.website) : true
      if(!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid Url',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return false
      }
      this.UpdateDetails(this.clientDetails.basic_details.client_users_id ? this.clientDetails.basic_details.client_users_id : this.clientDetails.basic_details.id)
      this.editBox = false
    },

    isValidURL(string) {
      var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
      return (res !== null)
    }
  }
}
</script>